<template>
  <div style="height: 100vh;overflow-y:hidden;" :style="{'background':'linear-gradient(180deg, #22C9FE 0%, #0172F2 100%)'}"> 
    <div class="machine-head" style="font-size:60px;letter-spacing:10px;height:120px;line-height:120px;
  text-shadow: 2px 2px 0 #000, -2px -2px 0 #000, 2px -2px 0 #000, -2px 2px 0 #000;position:relative" :style="{'color':'#fff','background':'#ea0000'}">
      <img style="width:100px;margin-right:10px;  ; position: absolute;" :src="row.score_logo?row.score_logo:'https://wa.ccachina.net/img/logo.58b57af4.png'" /> 
      <div style=" text-align:center">{{ row.title }}
        当前队伍
      </div>
        <img style="width:100px;position: absolute; float:right;top:20px;right:20px" src="https://wa.ccachina.net/img/logo.58b57af4.png" /> 
      <!-- <div>{{ row.saiqu_name }}</div> -->
    </div>
    <div style="background-image: linear-gradient(#f9f400 0%, #f9f400 48%, #f9f400 100%);
    height: 100px;
    letter-spacing:0.2em; 
  text-shadow: 2px 2px 0 white, -2px -2px 0 white, 2px -2px 0 white, -2px 2px 0 white;
    line-height: 100px;
    margin: 10px;
    text-align: center;
    color: #000;
    font-size: 70px;
    padding: 0px 20px;
    font-weight: bold;
    ">{{start.subject_name_group}}</div>
    <div style="background-image: linear-gradient(180deg, #002CDA 0%, #011C9D 48%, #002CDA 100%);
    height:auto;line-height:140px; margin:10px;text-align:left;color:#ffffffcc;font-size:80px;padding:0;
     font-weight:bold
    ">
    <div style="display: inline-block;padding:0 20px;font-size:70px;  background-image: linear-gradient(180deg, #9343FE 0%, #5A1AC9 48%, #9343FE 100%);text-align:center;margin-right:10px">
      出场顺序 {{thisIndex+1}}
    </div>
    {{start.subject_name_s}}</div>

    <div class="machine-box"  style="margin:10px;height:100%;background-image: linear-gradient(180deg, #002CDA 0%, #011C9D 48%, #002CDA 100%);" :style="{'color':row.show_font_color}">
      <div class="machine-content">
        <!-- <div class="machine-subject">{{start.subject_name_group}}</div> -->
        <!-- <div class="machine-subject">{{start.subject_name_s}}</div> -->
        <div class="machine-army" style="text-shadow: 4px 4px 4px #000000;color: #edc37d;font-family:diyfont ;">{{start.mingcheng}}</div>
      </div>
    </div>
  </div>
</template>
<style scoped>
/* 在你的组件的<style>标签中 */
@font-face {
  font-family: 'diyfont';
  src: url('~@/assets/font/509.ttf'); /* 使用webpack的别名~@指向src目录 */
  font-weight: normal;
  font-style: normal;
}

body {
  overflow-y: hidden;
}

.machine-table {
  width: 100%;
  /* color: #E3E59D; */
}

.machine-box {
  /* background: #0782B8; */
  text-align: center;
  /* color: #fff; */
  display: flex;
  justify-content: center; /*使子项目水平居中*/
  /*align-items: center; !*使子项目垂直居中*!*/
}

.machine-content {
  margin: 100px 0 0 0
}

.machine-content .machine-subject {
  font-size: 56px;
}

.machine-content .machine-army {
  font-size: 108px;
  margin-top: 40px;
  font-weight: bold;
  font-family: 'sun2';
  color: #ffffffcc;
}

.machine-box .machine-subject, .machine-box .machine-army {
  /*display: inline-block;*/
}

table th, table td {
  height: 50px;
  font-size: 16px;
  /*text-align: center;*/
  /*border: 1px solid gray;*/
}

table td a {
  color: #E3E59D;
}

table td a:hover {
  color: #F2EB92;
  text-decoration: underline;
}

table td a.disabled {
  color: #999;
}
table td a.disabled:hover {
  cursor: default;
  text-decoration: none;
}

table thead {
  color: white;
  background-color: #0782B8;
}

table tbody {
  display: block;
  /*width: calc(100% + 8px); !*这里的8px是滚动条的宽度*!*/
  height: 300px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

table thead tr, table tbody tr, table tfoot tr {
  box-sizing: border-box;
  table-layout: fixed;
  display: table;
  width: 100%;
}

table thead th:first-child {
  width: 100px;
  text-align: center;
}

table tbody td:first-child {
  text-align: center;
  width: 100px;
}

table thead th:nth-child(2) {
  width: 400px;
}

table tbody td:nth-child(2) {
  width: 400px;
}

table thead th:nth-child(3) {
  width: 360px;
}

table tbody td:nth-child(3) {
  width: 360px;
}

table thead th:nth-child(4) {
  width: 100px;
}

table tbody td:nth-child(4) {
  width: 100px;
}
/*table thead th:first-child, table tbody td:first-child{*/
/*  padding-left: 30px;*/
/*}*/

table tr:nth-child(even) {
  background: #0782B8;
}

.pointer {
  cursor: pointer;
}


.machine-head {
  /*background: url("../../assets/icon-machine-bg.png") no-repeat;*/
  /*background-size: 100% 205px;*/
  /*height: 205px;*/
  padding: 13px 20px;
  text-align: left;
  font-size: 36px;
  /* color: #fff; */
  font-weight: bold;
}


.flex-center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.flex-start {
  display: flex;
  justify-content: flex-start;
}

.flex-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}


</style>
<script>
export default {
  name: "ScoreStartArmy",
  props: {
    row: {
      type: Object,
      default: () => {}
    },
    start: {
      type: Object,
      default: () => {}
    },
    list:{
      type: Array,
      default: []
    }
  },
  components: {},
  data() {
    return {
      scoreList: [],
      formData: {
        id: 0
      },
      thisIndex:0,

      queryParam: {
        keywords: '',
        showScore: 1, // 只显示有分数的
        subjectRow: '',
        sjsq: [],
      },
      clientHeight: 0
    }

  },
  watch:{
    list(){ 
      let that = this
      console.log('watch list')
      this.list.map((item,index)=>{
        if(item.id == this.start.id){
          that.thisIndex = index
          return 
        }  
      }) 
    },
    start(){ 
      let that = this
      console.log('watch start')
      this.list.map((item,index)=>{
        if(item.id == this.start.id){
          that.thisIndex = index
          return 
        }  
      }) 
    }
  },
  mounted() {
    const that = this

    // 获取浏览器可视区域高度
    this.clientHeight = `${document.documentElement.clientHeight}`          //document.body.clientWidth;

    document.title = '队伍信息'
  },
  destroyed() {
  },
  computed: {},
  methods: {

  }
}
</script>



// WEBPACK FOOTER //
// ScoreStartArmy2.vue?6e7daa96